import { Button, H2 } from "@blueprintjs/core";
import { Users } from "@just-in-types";
import * as React from "react";
import { connect } from "react-redux";
import Ymm, { IYmmVehicle } from "../components/Ymm";
import { IState } from "../store";
import { addVehiclePick, AddVehiclePick } from "../store/actions";
import { IStrings } from "../store/reducers/strings";

import { firestore } from "../firebase";

interface INotificationsDispatchProps {
  onAddVehiclePick: AddVehiclePick;
}

interface INotificationsStateProps {
  currentUser: null | Users.UserWithAccount;
}

interface INotificationsProps {
  mobile?: string | null;
  handleSelected?: Function;
  businessId?: string | null;
  language: "eng" | "esp";
  siteId?: string | null;
  setNextClicked?: any;
  strings: IStrings;
  toggleLanguage: Function;
  welcomeFlow: boolean;
  displayBtn : boolean;
}

type NotificationsProps = INotificationsProps & INotificationsDispatchProps & INotificationsStateProps;

interface INotificationsState {
  businessId: null | string;
  loading: boolean;
  make: null | string;
  yearMax: null | number;
  yearMin: null | number;
  model: null | string;
  siteId: null | string;
}

class Notifications extends React.Component<NotificationsProps, INotificationsState> {
  private initialState: INotificationsState = {
    businessId: null,
    loading: false,
    make: null,
    model: null,
    siteId: null,
    yearMax: null,
    yearMin: null,
  };

  constructor(props: NotificationsProps) {
    super(props);

    this.state = this.initialState;
  }
  public async componentDidMount() {
    if (this.props.welcomeFlow) {
      this.props.setNextClicked(this.addPick);
    }
  }

  public render() {
    const { businessId, mobile, strings, welcomeFlow, siteId } = this.props;
    const { loading, model } = this.state;
    const addButtonDisabled = loading || !model || !mobile || mobile.length !== 10;

    return (
      <div style={{ margin: "5px", textAlign: "center", width: "100%" }}>
        <Button intent="success" onClick={(e) => this.props.toggleLanguage()} className="toggle_lng" style={{ margin : "0 auto", display: this.props.displayBtn?'block':'none' }}>
          {strings.toggleLanguage}
        </Button>

        {mobile &&
          !welcomeFlow && (
            <Button
              icon={"cross"}
              large={false}
              intent={"danger"}
              style={{ marginLeft: "1rem" }}
              onClick={this.closePick}
            />
          )}
        <H2 className={"new-pick"} style={{ marginTop: "20px", fontSize: "24px" }}>
          {strings.addNewPick}
        </H2>
        <Ymm businessId={businessId} siteId={siteId} disabled={loading} onChange={this.handleYmmSelect} strings={strings} />
        {welcomeFlow ? (
          ""
        ) : (
          <Button disabled={addButtonDisabled} intent="success" onClick={this.addPick}>
            {strings.add}
          </Button>
        )}
      </div>
    );
  }

  private handleYmmSelect = ({ make, yearMax, yearMin, model }: IYmmVehicle) => {
    // alert(make);
    // alert(model);
    // alert(yearMax);
    // alert(yearMin);
    this.setState({ make, yearMax, yearMin, model });
  };

  private addVehiclePickByMobile = async (mobile: string, vehicle: Users.VehiclePick) => {
    const make = vehicle.make.toUpperCase();
    const model = vehicle.model.toUpperCase();
    const combined = make + " " + model;
    firestore.collection("vehiclePicks").add({
      businessId: vehicle.businessId,
      combined,
      firstName: null,
      language: vehicle.language,
      make,
      mobile,
      model,
      siteId: vehicle.siteId,
      textSent: false,
      userId: null,
      yearMax: vehicle.yearMax,
      yearMin: vehicle.yearMin,
    });
  };

  private addPick = async () => {
    const { businessId, language, mobile, onAddVehiclePick, siteId } = this.props;
    const { make, yearMax, yearMin, model } = this.state;
    console.log(this.props);

    const query = await firestore
      .collection("users")
      .where("mobile", "==", mobile)
      .get();
    let user;
    if (query.docs && query.docs.length > 0) {
      user = query.docs[0].data();
    }

    if (!make) {
      return;
    }

    this.setState({ loading: true });

    if (mobile) {
      this.addVehiclePickByMobile(mobile, {
        businessId,
        language,
        make,
        model,
        siteId,
        yearMax,
        yearMin,
      } as Users.VehiclePick);
    }
    if (user && businessId && make && model && siteId && yearMax && yearMin) {
      await onAddVehiclePick(user.userId, {
        businessId,
        make,
        model,
        siteId,
        yearMax,
        yearMin,
      });
    }
    this.setState(this.initialState);
    if (this.props.handleSelected) {
      this.props.handleSelected();
    }
  };

  private closePick = () => {
    this.setState(this.initialState);
    if (this.props.handleSelected) {
      this.props.handleSelected();
    }
  };
}

const mapStateToProps = ({ users: { currentUser } }: IState) => ({
  currentUser,
});

const mapDispatchToProps = {
  onAddVehiclePick: addVehiclePick,
};

export default connect<INotificationsStateProps, INotificationsDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/views/Notifications.tsx